module.exports = "https://coursera_assets.s3.amazonaws.com/images/072334439fa6b83e31593a27bdb844da.png";